const backend = process.env.REACT_APP_BACKEND_URL || "https://dev.simplefirm.com";

// Public requests must not attach a token or trigger session refreshes.
const publicRequest = async (path, options = {}) => {
  const response = await fetch(new URL(path, backend), {
    ...options,
    credentials: "omit",
    headers: { Accept: "application/json", ...options.headers },
  });
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    const error = new Error("The request could not be completed.");
    error.data = data;
    throw error;
  }
  return data;
};

export const getAccessRequestStates = async (signal) => {
  const data = await publicRequest("/api/states/", { signal });
  const states = Array.isArray(data) ? data : data?.results;
  if (!Array.isArray(states) || !states.length) throw new Error("States are unavailable.");
  return states;
};

export const submitAccessRequest = (body) =>
  publicRequest("/api/access-requests/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
